















import infoRowsBlock from '@/components/Ui/ActiveInfoPage/Blocks/infoRows.vue'
import Vue from 'vue'
import richText from '@/components/RichText/RichText.vue'
import wikiBreadcrumbs from '@/components/wiki/breadcrumbs.vue'

export default Vue.extend({
  props: {
    scope: {},
    options: {}
  },
  components: {
    infoRowsBlock,
    richText,
    wikiBreadcrumbs
  }
})
